import { yup } from '@framework/validation';
import { ReferenceSchema } from '../../validation/ReferenceSchema';
import {
  ComputeExpression,
  IComputeExpressionValueReference,
  IComputeExpressionValueText,
} from '../ComputeExpression';
import { ComputeMath } from '../ComputeMath';

const ComputeExpressionValueItemSchema = yup
  .object({
    type: yup
      .string()
      .oneOf(['text', 'compute-expression-reference'])
      .required(),
    text: yup.string().notRequired(),
    attrs: yup
      .object({
        id: yup.string().notRequired(),
        label: yup.string().notRequired(),
        reference: ReferenceSchema.notRequired(),
      })
      .notRequired(),
  })
  .noUnknown()
  .required();

const ComputeExpressionRawSchema = yup
  .string()
  .label('Espressione')
  .default('')
  .required();

const ComputeExpressionBaseSchema: yup.ObjectSchema<ComputeExpression> =
  yup.object({
    value: yup
      .array(
        ComputeExpressionValueItemSchema as yup.ObjectSchema<
          IComputeExpressionValueReference | IComputeExpressionValueText
        >,
      )
      .default([])
      .min(1, "L'espressione non può essere vuota")
      .required(),
    raw: ComputeExpressionRawSchema,
  });

/**
 * Crea lo schema di validazione per un'espressione di calcolo
 * di tipo `ComputeExpression`.
 */
export const ComputeExpressionSchema: yup.ObjectSchema<ComputeExpression> =
  ComputeExpressionBaseSchema.shape({
    raw: ComputeExpressionRawSchema
      // Le expression numeriche richiedono un parser per essere validate
      .test({
        message: "Il campo ${path} deve essere un'espressione valida",
        name: 'validComputeExpression',
        exclusive: true,
        test(value) {
          // TODO true?
          if (!value || typeof value !== 'string') return false;
          try {
            const parsed = ComputeMath.parse(value.replace(/@/g, ''));
            return true;
          } catch (e) {
            if (
              e != null &&
              typeof e === 'object' &&
              'char' in e &&
              typeof e.char === 'number'
            ) {
              return this.createError({
                path: this.path,
                message: `L'espressione non è valida, è presente un errore alla posizione ${e.char}.`,
              });
            }
            return false;
          }
        },
      }),
  });

/**
 * Schema di validazione per un'espressione di calcolo di tipo `ComputeExpression`
 * di tipo stringa. In questo caso non andiamo a validare l'espressione con il parser
 * perché i caratteri speciali delle stringhe potrebbero generare errori.
 */
export const ComputeStringExpressionSchema: yup.ObjectSchema<ComputeExpression> =
  ComputeExpressionBaseSchema;
